import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const adminApi = (token) =>
    axios.create({
        baseURL: API,
        timeout: 15000,
        headers: { Authorization: `Bearer ${token}` },
    });

export const fetchArticles = (lang) =>
    api.get('/articles', { params: lang ? { language: lang } : {} }).then((r) => r.data);

export const fetchArticle = (slug) =>
    api.get(`/articles/${slug}`).then((r) => r.data);

export const submitEnquiry = (data) =>
    api.post('/leads', {
        name: data.name,
        phone: data.phone || '',
        email: data.email || '',
        vertical: 'dental',
        enquiry_type: data.treatment_interest || 'Dental enquiry',
        message: data.message || '',
        contact_method: data.contact_method || '',
        preferred_date: data.preferred_date || '',
        preferred_time: data.preferred_time || '',
        location: data.country || '',
        source_page: data.page || '',
        language: data.language || '',
        session_id: data.session_id || '',
        ...(data.utm || {}),
    }).then((r) => r.data);

export const readingMinutes = (body = '') => {
    const words = body.trim().split(/\s+/).filter(Boolean).length;
    return Math.max(1, Math.round(words / 200));
};
